import type { MigrationInterface, QueryRunner } from 'typeorm'

export class AddProjectsTable1678791203278 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration UP')
    await queryRunner.query(`
            CREATE TABLE IF NOT EXISTS "projects" (
                "id" integer PRIMARY KEY NOT NULL,
                "name" varchar NOT NULL,
                "number" varchar NOT NULL,
                "start_date" varchar,
                "end_date" varchar,
                "rrule" varchar,
                "destination_name" varchar NOT NULL,
                "destination_street" varchar NOT NULL,
                "destination_zip" varchar NOT NULL,
                "destination_city" varchar NOT NULL,
                "contact_name" varchar NOT NULL,
                "contact_phone" varchar NOT NULL,
                "customer" varchar NOT NULL,
                "customer_id" integer NOT NULL,
                "description" varchar NOT NULL,
                "show_description" integer NOT NULL,
                "parent_id" integer,
                "completable" boolean NOT NULL,
                "completed_date" varchar,
                "qr_token" varchar NOT NULL,
                "icon_class" varchar NOT NULL
            );
        `)
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration DOWN')
    await queryRunner.query(`
            DROP TABLE "projects";
        `)
  }
}
